export class CompanyAiInsights {
    constructor(companyId, data) {
        this.companyId = companyId;
        this.suggestions = data?.suggestions ?? [];
    }

    getCompanyId() {
        return this.companyId;
    }

    getSuggestions() {
        return this.suggestions;
    }
}


export class EnterpriseAiInsightsList {
    constructor(data, timeFrame) {
        this.items = data?.items ?? [];
        this.timeFrame = timeFrame;
    }

    getSortedBySeverity() {
        const severityOrder = { HIGH: 1, MEDIUM: 2, LOW: 3 };
        return this.items.sort((a, b) => severityOrder[a.severity] - severityOrder[b.severity]);
    }
}
